import React from 'react';
import { MDBBtn, MDBCol, MDBContainer, MDBRow, MDBTypography } from 'mdbreact';
import { Language } from '../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Vedio.scss";

const Vedio = (props: VedioProps) => {

    return <MDBContainer className="vedio">
        <MDBRow center middle>
            <MDBCol sm="12" className="item">
                <video src="https://www.youtube.com/watch?v=8Ynbzvd-etQ" />
            </MDBCol>
        </MDBRow>
    </MDBContainer>
};

interface VedioProps { }
export default Vedio;